import {AppState} from '../reducer';

export const errorStatusSelector = (state: AppState): string => state.errorReducer.error.status;
export const errorMessageSelector = (state: AppState): string => state.errorReducer.error.message;
